<div class="colored-bg-wrapper bg">
  <div class="colored-bg-container">
    <div class="colored-bg-content">
      <form class="new-password-form full-width" novalidate>
        <div class="header-block">
          <h2 class="formTitle">Enter your new password</h2>
        </div>

        @if (errorMessage) {
          <div>
            <p style="color: red;">{{ errorMessage }}</p>
          </div>
        }

        @if (isLoading) {
          <app-loading-overlay></app-loading-overlay>
        }

        @if (!showRegisterForm) {
          <div class="temp-login">
            <p class="white-message">Please verify with temporary password received in email.</p>
            @if (!isLoading) {
              <form novalidate class="inner-form" (ngSubmit)="confirmAccountRequest()">
                <div class="flex-col">
                  <div class="form-group">
                    <label for="loginEmailInput" class="align-left">Email</label>
                    <input type="email" [(ngModel)]="user.email" name="loginEmailInput" class="form-control" id="loginEmailInput" placeholder="">
                  </div>
                  <div class="form-group">
                    <label for="loginPasswordInput" class="align-left">Temporary Password</label>
                    <input type="password" [(ngModel)]="user.password" name="loginPasswordInput" class="form-control" id="loginPasswordInput" placeholder="">
                  </div>
                </div>
                <div class="submit-wrapper">
                  <button type="submit" [disabled]="(!user.email || user.email === '') || (!user.password || user.password === '')"
                    class="btn btn-primary btn-lg btn-block signin-btn">Verify
                  </button>
                </div>
              </form>
            }
          </div>
        }

        @if (showRegisterForm) {
          <div class="complete-registration">
            <p class="white-message">Enter your new password.</p>
            @if (!isLoading) {
              <form novalidate [formGroup]="passwordForm" class="inner-form" (ngSubmit)="completeAccount()">
                <div class="flex-col">
                  <div class="form-group">
                    <label for="register-passwordInput" class="align-left">Create Password</label>
                    <input type="password" formControlName="password" required minlength="6" maxlength="20" class="form-control">
                    @if (password && password.invalid && (password.dirty || password.touched)) {
                      <div>
                        @if (password.errors?.required) {
                          <div class="text-danger">Password is required</div>
                        }
                        @if (password.errors?.minlength) {
                          <div class="text-danger">Must be at least 6 characters long</div>
                        }
                        @if (password.errors?.pattern) {
                          <div class="text-danger">{{ _userService.passwordPatternDescription }}</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group">
                    <label for="register-passwordRepeatInput" class="align-left">Confirm Password</label>
                    <input type="password" formControlName="passwordConfirm" class="form-control">
                    @if (pwConfirm && pwConfirm.invalid && (pwConfirm.dirty || pwConfirm.touched)) {
                      <div class="text-danger">
                        @if (pwConfirm.errors['required']) {
                          <div>Password confirm is required</div>
                        }
                        @if (pwConfirm.errors['compare']) {
                          <div>Passwords do not match</div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="submit-wrapper">
                  <button type="submit" [disabled]="passwordForm.invalid" class="btn btn-primary btn-lg btn-block signin-btn">Submit</button>
                </div>
              </form>
            }
          </div>
        }
      </form>
    </div>
  </div>

  <div class="floating-logo">
    <img src="/uploads/system_images/yeeHRologo.png" width="200">
  </div>
</div>

